import { IconButton, styled } from '@mui/material'
import MuiDialog from '@mui/material/Dialog'
import { css } from '@emotion/react'
import type { DialogProps, FixedWidth } from './Dialog.types'

const sizeMap: { [key in FixedWidth]: number } = {
  sm: 484,
  md: 676,
  lg: 1184,
  xl: 1300,
}

const size = (fixedWidth: FixedWidth) => sizeMap[fixedWidth]

const sizeStyles = ({ fixedWidth }: Pick<DialogProps, 'fixedWidth'>) =>
  fixedWidth &&
  css`
    .MuiDialog-container {
      > .MuiPaper-root {
        min-width: ${size(fixedWidth)}px;
        max-width: ${size(fixedWidth)}px;
        width: ${size(fixedWidth)}px;
      }
    }
  `

const commonStyles = () => css`
  .MuiDialog-container {
    > .MuiPaper-root {
      border: thin solid rgba(0, 0, 0, 12%);
    }
  }
`

export const Dialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== 'fixedWidth',
})<DialogProps>`
  ${commonStyles};
  ${sizeStyles};
`

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 24px;
  top: 19px;
  padding: 0;
`
